import { Col } from "@amzn/stencil-react-components/layout";
import { Text } from "@amzn/stencil-react-components/text";
import { useQueryClient } from "@tanstack/react-query";
import React, { ChangeEvent, FC } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { isDevelopmentEnvironment } from "@/common/helpers/environment.helper";
import { MY_HARDWARE_QUERY_KEY } from "@/services/my-hardware/my-hardware.constants";
import { SCENARIO_QUERY_PARAM } from "../../mock-my-hardware-service";
import { resolveScenario, SCENARIO_LABELS, ScenarioId } from "../../scenarios";

const PICKER_ID = "my-hardware-scenario-picker";

export const LIVE_DATA_VALUE = "";
const LIVE_DATA_LABEL = "Live data";

export const MyHardwareScenarioPicker: FC = () => {
  const history = useHistory();
  const { pathname, search } = useLocation();
  const queryClient = useQueryClient();

  if (!isDevelopmentEnvironment()) {
    return null;
  }

  const requestedScenario = new URLSearchParams(search).get(SCENARIO_QUERY_PARAM);
  const selectedValue =
    requestedScenario === null ? LIVE_DATA_VALUE : resolveScenario(requestedScenario).id;

  const onChange = (event: ChangeEvent<HTMLSelectElement>): void => {
    const params = new URLSearchParams(search);
    if (event.target.value === LIVE_DATA_VALUE) {
      params.delete(SCENARIO_QUERY_PARAM);
    } else {
      params.set(SCENARIO_QUERY_PARAM, event.target.value);
    }
    history.replace(`${pathname}?${params.toString()}`);
    queryClient.invalidateQueries({ queryKey: MY_HARDWARE_QUERY_KEY });
  };

  return (
    <Col gridGap="S100" width="fit-content" data-testid="my-hardware-scenario-picker">
      <Text fontSize="T100" color="neutral70">
        <label htmlFor={PICKER_ID}>Simulation scenario</label>
      </Text>
      <select id={PICKER_ID} value={selectedValue} onChange={onChange}>
        <option value={LIVE_DATA_VALUE}>{LIVE_DATA_LABEL}</option>
        {(Object.entries(SCENARIO_LABELS) as [ScenarioId, string][]).map(([id, label]) => (
          <option key={id} value={id}>
            {label}
          </option>
        ))}
      </select>
    </Col>
  );
};
